// import ContractMdl from '@/models/HumanResource/HrContract'
import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/hr_contract'

export default async (contractId, data) => {
    try {
        const response = await axios.put(
            route + '/' + contractId,
            data
        )
        return response.data
    } catch (error) {
        error.response.data
    }
}
